import { ITabOption } from '@smartshell/ui-kit';

import { IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  title: '',
  description: '',
  group: null,
  path: [{ value: '' }, { value: '' }, { value: '' }],
  args: '',
  workingDirectory: '',
  accountsGroup: null,
  main_picture: '',
  screenshots: { value: [] },
  icon_path: '',
  run_as_admin: false,
  only_for_registered: false,
  age_rating: 0,
  free_run: false,
  template_id: null,
  template_title: undefined,
};

export const AGE_OPTIONS: Array<ITabOption<number>> = [
  {
    value: 0,
    title: '0+',
  },
  {
    value: 6,
    title: '6+',
  },
  {
    value: 12,
    title: '12+',
  },
  {
    value: 16,
    title: '16+',
  },
  {
    value: 18,
    title: '18+',
  },
];

export const MAX_SCREENSHOTS = 5;
